/**
 * This list contains default units for every supported sensor. The same list is used in the column mapper (see link).
 * These lists must *always* be in sync.
 *
 * **DO NOT MAKE ANY CHANGES HERE WITHOUT CHANGING THE ORIGINAL LIST IN THE COLUMN MAPPER.**
 * @link https://github.com/corva-ai/monorepo-node/blob/ee34ea5d9b27f3ee9f2881dc1925791f79e83d78/lambdas/enrichment-wrapper/src/lib/libs/column-mapper/consts.ts#L84C1-L145C3
 */
export const DEFAULT_COLUMN_MAPPER_UNITS = {
  bit_depth: 'ft',
  block_height: 'ft',
  hole_depth: 'ft',
  diff_press: 'psi',
  mud_flow_out: 'gal/min',
  hook_load: 'klbf',
  rop: 'ft/h',
  standpipe_pressure: 'psi',
  rotary_torque: 'ft-klbf',
  mud_flow_in: 'gal/min',
  mud_volume: 'bbl',
  weight_on_bit: 'klbf',
  gain_loss: 'bbl',
  pit_volume_1: 'bbl',
  pit_volume_2: 'bbl',
  pit_volume_3: 'bbl',
  pit_volume_4: 'bbl',
  pit_volume_5: 'bbl',
  pit_volume_6: 'bbl',
  pit_volume_7: 'bbl',
  pit_volume_8: 'bbl',
  trip_tank_volume_1: 'bbl',
  trip_tank_volume_2: 'bbl',
  trip_tank_volume_3: 'bbl',
  choke_pressure: 'psi',
  kill_pressure: 'psi',
  wellhead_pressure: 'psi',
  active_pit_volume: 'bbl',
  total_pit_volume: 'bbl',
  ad_wob_setpoint: 'klbf',
  ad_diff_press_setpoint: 'psi',
  ad_torque_limit: 'ft-klbf',
  das_time: 's',
  das_recommended_wob: 'klbf',
  das_recommended_flow: 'gal/min',
  das_doc: 'in/rev',
  das_mse: 'ksi',
  das_rop: 'ft/h',
  das_recommended_rop: 'ft/h',
  das_downhole_mse: 'ksi',
  das_rop_upper_limit: 'ft/h',
  das_rop_lower_limit: 'ft/h',
  das_wob_upper_limit: 'klbf',
  das_wob_lower_limit: 'klbf',
  das_rop_limiting_max: 'ft/h',
  boost_pump_flow_in: 'gal/min',
  mwd_annulus_ecd: 'ppg',
  mwd_annulus_pressure: 'psi',
  total_gas: '%EMA',
  annular_back_pressure: 'psi',
  mud_density: 'ppg',
  downhole_temp: 'F',
  mud_flow_out_percent: '%',
  rotary_rpm: 'rpm',
  pump_spm_1: 'strokes/min',
  pump_spm_2: 'strokes/min',
  pump_spm_3: 'strokes/min',
  pump_spm_4: 'strokes/min',
  pump_spm_total: 'strokes/min',
  boost_pump_strokes: 'strokes/min',
};
